import gql from 'graphql-tag';

export const googleDriveSharedDriveFragment = gql`
  fragment googleDriveSharedDriveFragment on GoogleDriveSharedDrive {
    dokkioClass
    credentialID
    sharedDriveID
    name
  }
`;
export default googleDriveSharedDriveFragment;
